/** Tự sinh bởi scripts/fetch-programs.mjs lúc build — không sửa tay. */
export default [
  {
    "programId": "100-plus-accelerator",
    "slug": "100-plus-accelerator",
    "name": "100+ Accelerator",
    "shortName": "100+",
    "organizer": "AB InBev và các đối tác",
    "kind": "CORPORATE_ACCELERATOR",
    "website": "https://www.100accelerator.com",
    "logoUrl": "",
    "edition": {
      "label": "Cohort 8",
      "rolling": false,
      "opensAt": null,
      "closesAt": null
    },
    "benefit": {
      "capitalTypes": [
        "IN_KIND"
      ],
      "note": "Kinh phí cho triển khai thử nghiệm, theo công bố của chương trình.",
      "max": {
        "amount": 10000000,
        "ccy": "USD",
        "fx": 26170,
        "fxDate": "2026-09-09"
      }
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "GLOBAL"
      ],
      "industries": [
        "CLIMATE",
        "AGRITECH",
        "LOGISTICS",
        "MATERIALS"
      ],
      "hardRequirements": [
        "Giải pháp khớp một trong các bài toán bền vững chương trình công bố",
        "Sẵn sàng triển khai thử nghiệm với tập đoàn"
      ]
    },
    "process": {
      "applyUrl": "https://www.100accelerator.com/"
    },
    "content": {
      "summary": "Chương trình tăng tốc do doanh nghiệp vận hành, tập trung vào các giải pháp bền vững triển khai được trong chuỗi cung ứng.",
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.100accelerator.com/",
          "fetchedAt": "2026-09-12",
          "note": "Trang chương trình chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-20T14:20:25.453Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "aws-activate",
    "slug": "aws-activate",
    "name": "AWS Activate",
    "shortName": "AWS Activate",
    "organizer": "Amazon Web Services",
    "kind": "CLOUD_CREDITS",
    "website": "https://aws.amazon.com/startups/credits/",
    "logoUrl": "",
    "edition": {
      "label": "Nhận liên tục",
      "rolling": true,
      "opensAt": null,
      "closesAt": null
    },
    "benefit": {
      "capitalTypes": [
        "IN_KIND"
      ],
      "note": "Tín dụng dùng cho dịch vụ AWS, không quy đổi thành tiền mặt.",
      "max": {
        "amount": 20000000,
        "ccy": "USD",
        "fx": 26170,
        "fxDate": "2026-09-09"
      }
    },
    "eligibility": {
      "stages": [
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "GLOBAL"
      ],
      "industries": [
        "SAAS_B2B",
        "AI",
        "FINTECH",
        "HEALTHTECH",
        "GAMING"
      ],
      "hardRequirements": [
        "Doanh nghiệp thành lập trong vòng 10 năm và chưa qua vòng Series B",
        "Có tài khoản AWS hợp lệ ở gói trả phí",
        "Bậc Portfolio cần được một đơn vị đối tác của chương trình giới thiệu"
      ]
    },
    "process": {
      "applyUrl": "https://aws.amazon.com/startups/credits/"
    },
    "content": {
      "summary": "Chương trình cấp tín dụng sử dụng dịch vụ AWS. Bậc Founders nộp trực tiếp; bậc Portfolio cần qua đơn vị đối tác giới thiệu.",
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://aws.amazon.com/startups/credits/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chương trình chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-20T14:20:20.573Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "developpp-classic",
    "slug": "developpp-classic",
    "name": "develoPPP Classic",
    "shortName": "develoPPP",
    "organizer": "Bộ Hợp tác Kinh tế và Phát triển Liên bang Đức",
    "kind": "MATCHING_GRANT",
    "website": "https://www.developpp.de",
    "logoUrl": "",
    "edition": {
      "label": "Kỳ đang mở",
      "rolling": false,
      "opensAt": null,
      "closesAt": "2026-09-30"
    },
    "benefit": {
      "capitalTypes": [
        "GRANT"
      ],
      "note": "Tài trợ công tối đa 50% chi phí dự án, phần còn lại doanh nghiệp đối ứng.",
      "max": {
        "amount": 200000000,
        "ccy": "EUR",
        "fx": 30500,
        "fxDate": "2026-09-11"
      }
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "VN"
      ],
      "industries": [
        "CLIMATE",
        "AGRITECH",
        "LOGISTICS",
        "ENERGY"
      ],
      "hardRequirements": [
        "Dự án vừa có lợi ích phát triển vừa có tính thương mại",
        "Doanh nghiệp phải đối ứng ít nhất 50% chi phí dự án",
        "Yêu cầu về doanh thu và số năm hoạt động thay đổi theo từng đợt"
      ]
    },
    "process": {
      "applyUrl": "https://www.developpp.de/"
    },
    "content": {
      "summary": "Chương trình tài trợ đối ứng của Đức cho dự án kinh doanh bền vững tại các thị trường đang phát triển, trong đó có Việt Nam.",
      "tips": [
        "Đây là tài trợ đối ứng, không phải cấp toàn bộ. Doanh nghiệp phải chứng minh được khả năng bỏ phần vốn còn lại."
      ]
    },
    "alumni": {
      "items": [
        {
          "name": "Festo Didactic, Schneider Electric Việt Nam và IBS",
          "url": "",
          "whatTheyDo": "Lập trung tâm đào tạo nghề cho kỹ thuật viên điện gió và điện mặt trời tại Việt Nam.",
          "industries": [
            "ENERGY",
            "EDTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Les Vergers du Mékong",
          "url": "",
          "whatTheyDo": "Phát triển vùng trồng và chế biến trái cây ở đồng bằng sông Cửu Long.",
          "industries": [
            "AGRITECH",
            "FOODBEV"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Nestlé",
          "url": "",
          "whatTheyDo": "Nâng mức canh tác bền vững cho nông hộ trồng cà phê ở Đông Nam Á.",
          "industries": [
            "AGRITECH",
            "FOODBEV"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Continental AG",
          "url": "",
          "whatTheyDo": "Số hoá truy xuất nguồn gốc chuỗi cung ứng cao su tại Indonesia.",
          "industries": [
            "AGRITECH",
            "LOGISTICS"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "BASF, Procter & Gamble và Cargill",
          "url": "",
          "whatTheyDo": "Thu mua dầu dừa bền vững tại Philippines và Indonesia.",
          "industries": [
            "AGRITECH",
            "FOODBEV"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "develoPPP hợp tác với doanh nghiệp để làm dự án phát triển, nên đây là các dự án đã được tài trợ chứ không phải startup được rót vốn. Hai dự án ở Việt Nam, ba dự án còn lại trong khu vực để bạn hình dung phạm vi. Mô tả lấy theo đúng cách chương trình ghi trên trang.",
      "source": "https://www.developpp.de/en/projects-success-stories/",
      "verifiedAt": "2026-09-27"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.developpp.de/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chương trình chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-27T08:55:37.184Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "global-innovation-fund",
    "slug": "global-innovation-fund",
    "name": "Global Innovation Fund",
    "shortName": "GIF",
    "organizer": "Global Innovation Fund",
    "kind": "BLENDED_IMPACT",
    "website": "https://www.globalinnovation.fund",
    "logoUrl": "",
    "edition": {
      "label": "Cửa sổ gần nhất",
      "rolling": false,
      "opensAt": null,
      "closesAt": "2025-01-15"
    },
    "benefit": {
      "capitalTypes": [
        "GRANT",
        "EQUITY",
        "DEBT"
      ],
      "note": "Mức và hình thức thay đổi theo giai đoạn của giải pháp."
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "GLOBAL"
      ],
      "industries": [
        "CLIMATE",
        "HEALTHTECH",
        "EDTECH",
        "AGRITECH"
      ],
      "hardRequirements": [
        "Giải pháp nhắm tới một thách thức phát triển cụ thể",
        "Đã có bằng chứng về hiệu quả và tiềm năng mở rộng"
      ]
    },
    "process": {
      "applyUrl": "https://www.globalinnovation.fund/apply-for-funding/"
    },
    "content": {
      "summary": "Quỹ kết hợp tài trợ, vốn cổ phần và cho vay cho các giải pháp giải quyết thách thức phát triển, nhận hồ sơ theo cửa sổ công bố.",
      "tips": []
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.globalinnovation.fund/apply-for-funding/",
          "fetchedAt": "2026-09-11",
          "note": "Trang nộp hồ sơ"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-20T14:20:22.878Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "google-startups-accelerator-sea",
    "slug": "google-for-startups-accelerator-sea",
    "name": "Google for Startups Accelerator: Đông Nam Á",
    "shortName": "GFSA Đông Nam Á",
    "organizer": "Google for Startups",
    "kind": "EQUITY_FREE_ACCELERATOR",
    "website": "https://startup.google.com/programs/accelerator/southeast-asia/",
    "logoUrl": "",
    "edition": {
      "label": "Kỳ 2026",
      "rolling": false,
      "opensAt": null,
      "closesAt": "2026-06-20"
    },
    "benefit": {
      "capitalTypes": [
        "IN_KIND"
      ],
      "note": "Không có khoản đầu tư tiền mặt và không lấy cổ phần. Hỗ trợ gồm cố vấn kỹ thuật và tín dụng đám mây tuỳ điều kiện."
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "SEA"
      ],
      "industries": [
        "AI",
        "SAAS_B2B"
      ],
      "hardRequirements": [
        "Startup tại Đông Nam Á đã có dấu hiệu thị trường",
        "Sản phẩm dùng AI hoặc công nghệ lõi",
        "Người sáng lập và trưởng nhóm kỹ thuật tham gia đầy đủ chương trình"
      ]
    },
    "process": {
      "applyUrl": "https://startup.google.com/programs/accelerator/southeast-asia/"
    },
    "content": {
      "summary": "Chương trình tăng tốc không lấy cổ phần của Google dành cho startup Đông Nam Á, nhấn mạnh cố vấn kỹ thuật.",
      "tips": [
        "Không lấy cổ phần là điểm đáng chú ý. Cái giá phải trả là thời gian của người sáng lập và trưởng nhóm kỹ thuật trong suốt chương trình."
      ]
    },
    "alumni": {
      "items": [
        {
          "name": "Fundiin",
          "url": "",
          "whatTheyDo": "Giải pháp mua trước trả sau cho thương mại điện tử và bán lẻ.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Gimo",
          "url": "",
          "whatTheyDo": "Cho người lao động nhận phần lương đã làm trước kỳ trả lương.",
          "industries": [
            "FINTECH",
            "HRTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Docosan",
          "url": "",
          "whatTheyDo": "Sàn đặt lịch khám và dịch vụ y tế.",
          "industries": [
            "HEALTHTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Filum.ai",
          "url": "",
          "whatTheyDo": "Nền tảng quản trị trải nghiệm khách hàng vận hành bằng AI.",
          "industries": [
            "SAAS_B2B",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Foodmap Asia",
          "url": "",
          "whatTheyDo": "Sàn B2B và B2C kết nối nông dân, nhà sản xuất với người mua.",
          "industries": [
            "AGRITECH",
            "ECOMMERCE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "TopCV",
          "url": "",
          "whatTheyDo": "Nền tảng tuyển dụng và hồ sơ ứng tuyển trực tuyến.",
          "industries": [
            "HRTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "INKR",
          "url": "",
          "whatTheyDo": "Nền tảng cho tác giả và nhà xuất bản truyện tranh.",
          "industries": [
            "MEDIA"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Vbee",
          "url": "",
          "whatTheyDo": "Doanh nghiệp AI hội thoại tiếng Việt.",
          "industries": [
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "BUSMAP",
          "url": "",
          "whatTheyDo": "Dịch vụ tra cứu và di chuyển bằng phương tiện công cộng cho các nước ASEAN.",
          "industries": [
            "MOBILITY"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "enFarm Agritech",
          "url": "",
          "whatTheyDo": "Phần mềm tư vấn canh tác bằng AI và cảm biến đất thông minh.",
          "industries": [
            "AGRITECH",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Chương trình đã có hơn 30 doanh nghiệp Việt Nam đi qua; đây chỉ là một phần được chọn để bạn hình dung. Mô tả lấy theo đúng cách chương trình ghi trên trang. Đây là chương trình cố vấn và hỗ trợ kỹ thuật, không rót vốn.",
      "source": "https://startup.google.com/programs/accelerator/southeast-asia/",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://startup.google.com/programs/accelerator/southeast-asia/",
          "fetchedAt": "2026-09-12",
          "note": "Trang chương trình chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-27T08:55:43.794Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "google-startups-cloud",
    "slug": "google-for-startups-cloud",
    "name": "Google for Startups Cloud Program",
    "shortName": "Google Cloud",
    "organizer": "Google Cloud",
    "kind": "CLOUD_CREDITS",
    "website": "https://cloud.google.com/startup",
    "logoUrl": "",
    "edition": {
      "label": "Nhận liên tục",
      "rolling": true,
      "opensAt": null,
      "closesAt": null
    },
    "benefit": {
      "capitalTypes": [
        "IN_KIND"
      ],
      "note": "Tín dụng dùng cho dịch vụ Google Cloud, không quy đổi thành tiền mặt và không áp dụng cho mọi dịch vụ bên thứ ba.",
      "max": {
        "amount": 35000000,
        "ccy": "USD",
        "fx": 26170,
        "fxDate": "2026-09-09"
      }
    },
    "eligibility": {
      "stages": [
        "PROTOTYPE",
        "PRESEED",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "GLOBAL"
      ],
      "industries": [
        "SAAS_B2B",
        "AI",
        "FINTECH",
        "HEALTHTECH",
        "WEB3"
      ],
      "hardRequirements": [
        "Doanh nghiệp công nghệ số, còn trong giới hạn tuổi công ty theo từng bậc",
        "Bậc Scale yêu cầu đã gọi được vốn từ quỹ đầu tư",
        "Chưa nhận quá ngưỡng tín dụng của chương trình trước đó"
      ]
    },
    "process": {
      "applyUrl": "https://cloud.google.com/startup"
    },
    "content": {
      "summary": "Chương trình cấp tín dụng sử dụng dịch vụ Google Cloud cho startup, chia theo hai bậc tuỳ mức độ trưởng thành của doanh nghiệp.",
      "tips": [
        "Tín dụng không phải tiền mặt. Nó giảm chi phí hạ tầng chứ không thay được vốn lưu động — đừng đưa vào kế hoạch dòng tiền như một khoản thu."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://cloud.google.com/startup/benefits",
          "fetchedAt": "2026-09-11",
          "note": "Trang quyền lợi chương trình"
        },
        {
          "url": "https://cloud.google.com/terms/startup-program-tos",
          "fetchedAt": "2026-09-11",
          "note": "Điều khoản chương trình"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-20T14:20:20.172Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "l-camp-vietnam",
    "slug": "l-camp-vietnam",
    "name": "L-CAMP Vietnam",
    "shortName": "L-CAMP",
    "organizer": "Lotte Ventures Vietnam",
    "kind": "OPEN_INNOVATION",
    "website": "https://lotteventures.vn",
    "logoUrl": "",
    "edition": {
      "label": "Kỳ 2026",
      "rolling": false,
      "opensAt": null,
      "closesAt": "2026-06-19"
    },
    "benefit": {
      "capitalTypes": [
        "IN_KIND"
      ],
      "note": "Triển khai thử nghiệm cùng các đơn vị trong hệ sinh thái LOTTE tại Việt Nam. Ngân sách thử nghiệm không công bố trên nguồn chính thức."
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN"
      ],
      "industries": [
        "ECOMMERCE",
        "RETAILTECH",
        "FOODBEV",
        "LOGISTICS",
        "FINTECH",
        "AI",
        "SAAS_B2B"
      ],
      "hardRequirements": [
        "Sản phẩm đủ hoàn thiện để triển khai thử nghiệm thật",
        "Bài toán khớp nhu cầu của một đơn vị thuộc LOTTE"
      ]
    },
    "process": {
      "applyUrl": "https://lotteventures.vn/"
    },
    "content": {
      "summary": "Chương trình đổi mới mở giữa startup Việt Nam và hệ sinh thái LOTTE, tập trung vào triển khai thử nghiệm thực tế.",
      "tips": [
        "Triển khai thử nghiệm không đồng nghĩa hợp đồng mua hàng hay khoản đầu tư. Đây là cơ hội có khách hàng doanh nghiệp lớn, không phải cơ hội gọi vốn."
      ]
    },
    "alumni": {
      "items": [
        {
          "name": "Parsley",
          "url": "",
          "whatTheyDo": "Nhóm thương hiệu làm đẹp dựa trên bằng chứng khoa học, dẫn đầu là Men Stay Simplicity.",
          "industries": [
            "RETAILTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2026",
          "outcomeNote": ""
        },
        {
          "name": "DayLaDau",
          "url": "",
          "whatTheyDo": "Nền tảng đặt chỗ nghỉ ngắn ngày gần nơi ở cho người trẻ.",
          "industries": [
            "TRAVEL"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2026",
          "outcomeNote": ""
        }
      ],
      "note": "Khoá 1 năm 2026 gồm năm doanh nghiệp: CNV CDP, Parsley, HapBio, DayLaDau và Loudio. Trang của chương trình chỉ mô tả hai trong số đó nên ba tên còn lại chỉ nêu ở đây. Tham gia chương trình là được chạy thử cùng hệ sinh thái LOTTE và có thể dẫn tới đầu tư, không phải đã được rót vốn.",
      "source": "https://lotteventures.vn/portfolio/l-camp/",
      "verifiedAt": "2026-09-27"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://lotteventures.vn/lotte-ventures-vietnam-officially-launched-the-l-camp-vietnam-2026-program-to-promote-collaborative-pilot-programs-between-vietnamese-startups-and-the-lotte-group-ecosystem/",
          "fetchedAt": "2026-09-12",
          "note": "Thông cáo chính thức chương trình kỳ 2026"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-27T08:55:38.495Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "natif-ai-2026",
    "slug": "natif-ai-2026",
    "name": "Tài trợ nhiệm vụ đổi mới công nghệ ứng dụng AI năm 2026",
    "shortName": "NATIF AI 2026",
    "organizer": "Quỹ Đổi mới công nghệ quốc gia (NATIF), Bộ Khoa học và Công nghệ",
    "kind": "GOVERNMENT_SUPPORT",
    "website": "https://www.natif.gov.vn",
    "logoUrl": "",
    "edition": {
      "label": "Giai đoạn 1, năm 2026",
      "rolling": false,
      "opensAt": "2026-09-09",
      "closesAt": "2026-10-10"
    },
    "benefit": {
      "capitalTypes": [
        "GRANT"
      ],
      "note": "Quỹ tài trợ tối đa 50% tổng kinh phí nhiệm vụ, không quá 3 tỷ đồng mỗi nhiệm vụ. Doanh nghiệp đối ứng tối thiểu 50% bằng tiền. Kinh phí cấp theo chứng từ, mỗi nhiệm vụ thực hiện không quá 12 tháng."
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SEED_PLUS",
        "SERIES_A",
        "LATER"
      ],
      "geos": [
        "VN"
      ],
      "industries": [
        "HEALTHTECH",
        "LOGISTICS",
        "AGRITECH",
        "AI",
        "MANUFACTURING"
      ],
      "hardRequirements": [
        "Có tư cách pháp nhân, ngành nghề kinh doanh phù hợp lĩnh vực nhiệm vụ",
        "Có bài toán AI cụ thể và dữ liệu sẵn sàng, kết quả ứng dụng trực tiếp được",
        "Thuộc một trong ba hướng: thay thế công nghệ nhập khẩu, làm chủ hoặc nội địa hoá công nghệ, có hợp đồng chuyển giao công nghệ",
        "Cam kết đối ứng tối thiểu 50% kinh phí bằng tiền",
        "Không còn nợ quyết toán hoặc hoàn trả kinh phí của nhiệm vụ dùng ngân sách trước đó"
      ]
    },
    "process": {
      "applyUrl": "https://oms.natif.vn"
    },
    "content": {
      "summary": "Quỹ NATIF tài trợ đến 3 tỷ đồng cho doanh nghiệp ứng dụng AI vào bài toán thực tế của mình, ưu tiên chế biến chế tạo, nông nghiệp, y tế dược, logistics, thương mại dịch vụ. Đợt 2026 chọn 15 nhiệm vụ; từ 2027 dự kiến khoảng 50 nhiệm vụ mỗi năm. Đây là tài trợ đối ứng của nhà nước, không phải chương trình tăng tốc.",
      "tips": [
        "Startup AI thường vào cuộc ở vai đơn vị phát triển giải pháp: tìm một khách hàng doanh nghiệp có sẵn dữ liệu và bài toán để họ đứng tên xin tài trợ. Lõi AI vẫn thuộc bên phát triển, phần tích hợp và dữ liệu thuộc doanh nghiệp được tài trợ.",
        "Kê khai phần xin ngân sách bằng chi phí phát sinh mới (chuyên gia, dữ liệu, GPU, thử nghiệm, kiểm định). Lương nhân sự có sẵn và hạ tầng cũ nên để vào phần đối ứng.",
        "Dự án chỉ cài phần mềm có sẵn sẽ khó đạt: cần chứng minh tính đổi mới công nghệ và hiệu quả đo được (năng suất, chi phí, doanh thu).",
        "Nếu số hồ sơ đạt vượt kinh phí, hồ sơ nộp sớm được ưu tiên. Hạn 17h00 ngày 10/10/2026 tại oms.natif.vn; cần hỏi trước thì đăng ký tại khaosat.natif.gov.vn.",
        "Từ hồ sơ hợp lệ đến ký hợp đồng mất khoảng 60 ngày; kết quả dự kiến công bố ngày 15/12/2026."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.natif.gov.vn/",
          "fetchedAt": "2026-10-05",
          "note": "Trang chính thức NATIF: hạn nộp, mức tài trợ, kênh nộp"
        },
        {
          "url": "https://vtv.vn/keu-goi-de-xuat-nhiem-vu-ung-dung-ai-tai-tro-toi-da-3-ty-dong-100260917160129031.htm",
          "fetchedAt": "2026-10-05",
          "note": "VTV 17/09/2026: ngành, địa bàn ưu tiên, nguyên tắc ưu tiên nộp sớm"
        }
      ],
      "lastVerifiedAt": "2026-10-05"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-10-05T04:25:38.324Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "pepsico-greenhouse-apac",
    "slug": "pepsico-greenhouse-apac",
    "name": "PepsiCo Greenhouse Accelerator — châu Á Thái Bình Dương",
    "shortName": "Greenhouse APAC",
    "organizer": "PepsiCo",
    "kind": "CORPORATE_ACCELERATOR",
    "website": "https://greenhouseaccelerator.com",
    "logoUrl": "",
    "edition": {
      "label": "Kỳ 2026",
      "rolling": false,
      "opensAt": null,
      "closesAt": null
    },
    "benefit": {
      "capitalTypes": [
        "IN_KIND"
      ],
      "note": "Mức hỗ trợ tiền mặt chưa xác nhận được trên nguồn chính thức đang công khai."
    },
    "eligibility": {
      "stages": [
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "APAC"
      ],
      "industries": [
        "CLIMATE",
        "AGRITECH",
        "LOGISTICS",
        "MATERIALS"
      ],
      "hardRequirements": [
        "Giải pháp sẵn sàng triển khai trong chuỗi cung ứng của tập đoàn"
      ]
    },
    "process": {
      "applyUrl": "https://greenhouseaccelerator.com/"
    },
    "content": {
      "summary": "Chương trình tăng tốc khu vực châu Á Thái Bình Dương của PepsiCo, tập trung vào bền vững và chuỗi cung ứng.",
      "tips": []
    },
    "alumni": {
      "items": [
        {
          "name": "Alternō",
          "url": "",
          "whatTheyDo": "Lưu trữ nhiệt bằng cát, thay nhiên liệu đốt trong sấy nông sản và cấp nhiệt công nghiệp.",
          "industries": [
            "CLIMATE",
            "ENERGY"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2024",
          "outcomeNote": ""
        },
        {
          "name": "Grac",
          "url": "",
          "whatTheyDo": "Phần mềm quản lý thu gom rác và tái chế cho chính quyền địa phương và doanh nghiệp.",
          "industries": [
            "CLIMATE"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2024",
          "outcomeNote": ""
        },
        {
          "name": "Beijing AIForce Technology",
          "url": "",
          "whatTheyDo": "Ứng dụng AI cho các bài toán bền vững trong chuỗi giá trị thực phẩm. Quán quân khoá 2025.",
          "industries": [
            "AI",
            "CLIMATE"
          ],
          "stage": "",
          "geo": "APAC",
          "roundDate": "2025",
          "outcomeNote": ""
        },
        {
          "name": "Circular Unite",
          "url": "",
          "whatTheyDo": "Quản lý rác thải bằng AI và sàn biến rác thành nguyên liệu đầu vào.",
          "industries": [
            "CLIMATE"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": "2025",
          "outcomeNote": ""
        },
        {
          "name": "Bali Waste Cycle",
          "url": "",
          "whatTheyDo": "Dịch vụ thu gom và tái chế rác lưu động.",
          "industries": [
            "CLIMATE"
          ],
          "stage": "",
          "geo": "SEA",
          "roundDate": "2025",
          "outcomeNote": ""
        },
        {
          "name": "Calyx.eco",
          "url": "",
          "whatTheyDo": "Đánh giá vòng đời sản phẩm bằng AI cho nông nghiệp bền vững.",
          "industries": [
            "AGRITECH",
            "CLIMATE"
          ],
          "stage": "",
          "geo": "APAC",
          "roundDate": "2025",
          "outcomeNote": ""
        }
      ],
      "note": "Khoá 2024 có hai doanh nghiệp Việt Nam vào vòng chung kết; khoá 2025 không có doanh nghiệp Việt Nam nào. Chương trình trao giải thưởng và cơ hội chạy thử cùng PepsiCo, không đổi cổ phần.",
      "source": "https://theinvestor.vn/vietnamese-startups-chosen-for-pepsicos-top-10-greenhouse-accelerator-apac-d9973.html",
      "verifiedAt": "2026-09-27"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://greenhouseaccelerator.com/",
          "fetchedAt": "2026-09-12",
          "note": "Trang chương trình chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-27T08:55:42.464Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "qualcomm-vietnam-innovation-challenge",
    "slug": "qualcomm-vietnam-innovation-challenge",
    "name": "Qualcomm Vietnam Innovation Challenge",
    "shortName": "QVIC",
    "organizer": "Qualcomm",
    "kind": "PRIZE_CHALLENGE",
    "website": "https://www.qualcomm.com/company/locations/vietnam",
    "logoUrl": "",
    "edition": {
      "label": "Kỳ 2026",
      "rolling": false,
      "opensAt": null,
      "closesAt": null
    },
    "benefit": {
      "capitalTypes": [
        "GRANT",
        "IN_KIND"
      ],
      "note": "Giải thưởng ba đội dẫn đầu lần lượt 100, 75 và 50 nghìn USD theo công bố của chương trình, kèm chương trình ươm tạo và hỗ trợ về sở hữu trí tuệ.",
      "max": {
        "amount": 10000000,
        "ccy": "USD",
        "fx": 26170,
        "fxDate": "2026-09-09"
      }
    },
    "eligibility": {
      "stages": [
        "PROTOTYPE",
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN"
      ],
      "industries": [
        "AI",
        "SEMICONDUCTOR",
        "ROBOTICS",
        "MOBILITY"
      ],
      "hardRequirements": [
        "Có sản phẩm công nghệ hoặc tài sản trí tuệ riêng",
        "Đủ năng lực tham gia chương trình ươm tạo kéo dài"
      ]
    },
    "process": {
      "applyUrl": "https://www.qualcomm.com/company/locations/vietnam"
    },
    "content": {
      "summary": "Cuộc thi ươm tạo công nghệ dành cho startup tại Việt Nam, tập trung vào phần cứng, AI và công nghệ lõi.",
      "tips": []
    },
    "alumni": {
      "items": [
        {
          "name": "Rainscales Vietnam",
          "url": "",
          "whatTheyDo": "Nền tảng eMagicEyes kết hợp thị giác máy tính và kinh nghiệm người vận hành để giám sát an toàn nhà máy. Giải nhất 2025.",
          "industries": [
            "AI",
            "MANUFACTURING"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2025",
          "outcomeNote": ""
        },
        {
          "name": "Viet Dynamic",
          "url": "",
          "whatTheyDo": "Hệ thống sản xuất thông minh ứng dụng AI để tối ưu vận hành nhà máy. Giải nhì 2025.",
          "industries": [
            "AI",
            "MANUFACTURING"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2025",
          "outcomeNote": ""
        },
        {
          "name": "Enfarm Agritech",
          "url": "",
          "whatTheyDo": "Cảm biến đo dinh dưỡng đất theo thời gian thực kèm trợ lý AI khuyến nghị bón phân. Giải ba 2025.",
          "industries": [
            "AGRITECH",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2025",
          "outcomeNote": ""
        },
        {
          "name": "Vbee",
          "url": "",
          "whatTheyDo": "Nền tảng AI hội thoại cho tổng đài và ứng dụng giọng nói tiếng Việt. Giải nhất 2024.",
          "industries": [
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2024",
          "outcomeNote": ""
        },
        {
          "name": "HSPTek",
          "url": "",
          "whatTheyDo": "Thiết bị đeo giám sát tĩnh điện theo thời gian thực cho an toàn nhà xưởng. Giải nhì 2024.",
          "industries": [
            "MANUFACTURING",
            "ROBOTICS"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2024",
          "outcomeNote": ""
        },
        {
          "name": "Met EV",
          "url": "",
          "whatTheyDo": "Xe hai bánh điện giá phổ thông kèm giải pháp đổi pin điều phối bằng AI. Giải ba 2024.",
          "industries": [
            "MOBILITY",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": "2024",
          "outcomeNote": ""
        }
      ],
      "note": "Đây là các đội đoạt giải chung kết hai mùa gần nhất, không phải toàn bộ doanh nghiệp từng dự thi. Chương trình trao giải thưởng tiền mặt và quyền truy cập mạng lưới của Qualcomm, không đổi cổ phần.",
      "source": "https://innoex.vn/qualcomm-announces-winners-for-qualcomm-vietnam-innovation-challenge-2025-at-innoex/",
      "verifiedAt": "2026-09-26"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://www.qualcomm.com/company/locations/vietnam",
          "fetchedAt": "2026-09-12",
          "note": "Trang Qualcomm Việt Nam"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-27T08:55:41.146Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "shinhan-innoboost",
    "slug": "shinhan-innoboost",
    "name": "Global Shinhan InnoBoost",
    "shortName": "InnoBoost",
    "organizer": "Shinhan Future’s Lab Việt Nam",
    "kind": "OPEN_INNOVATION",
    "website": "https://futureslab.com.vn/innoboost/",
    "logoUrl": "",
    "edition": {
      "label": "Kỳ 2026",
      "rolling": false,
      "opensAt": "2026-04-01",
      "closesAt": "2026-05-03"
    },
    "benefit": {
      "capitalTypes": [
        "GRANT",
        "IN_KIND"
      ],
      "note": "Mức hỗ trợ theo thông tin chương trình kỳ 2026, kèm cơ hội triển khai thử nghiệm.",
      "max": {
        "amount": 200000000,
        "ccy": "VND",
        "fx": null,
        "fxDate": null
      }
    },
    "eligibility": {
      "stages": [
        "PROTOTYPE",
        "SEED",
        "SERIES_A"
      ],
      "geos": [
        "VN"
      ],
      "industries": [
        "FINTECH",
        "AI",
        "MARTECH",
        "ECOMMERCE"
      ],
      "hardRequirements": [
        "Đã có sản phẩm chạy được và dấu hiệu nhu cầu",
        "Có bài toán cụ thể để triển khai thử nghiệm với một đơn vị thuộc Shinhan"
      ]
    },
    "process": {
      "applyUrl": "https://futureslab.com.vn/innoboost/"
    },
    "content": {
      "summary": "Chương trình đổi mới mở của Shinhan tại Việt Nam, kết hợp hỗ trợ tài chính và triển khai thử nghiệm với các đơn vị trong tập đoàn.",
      "tips": []
    },
    "alumni": {
      "items": [
        {
          "name": "Filum.ai",
          "url": "",
          "whatTheyDo": "Nền tảng quản trị trải nghiệm khách hàng vận hành bằng AI.",
          "industries": [
            "SAAS_B2B",
            "AI"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "1Long",
          "url": "",
          "whatTheyDo": "Ứng dụng tích luỹ và đầu tư số tiền nhỏ cho người mới bắt đầu.",
          "industries": [
            "FINTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "Papaya Insurtech",
          "url": "",
          "whatTheyDo": "Hạ tầng số cho bảo hiểm sức khoẻ của doanh nghiệp.",
          "industries": [
            "INSURTECH",
            "HEALTHTECH"
          ],
          "stage": "",
          "geo": "VN",
          "roundDate": null,
          "outcomeNote": ""
        },
        {
          "name": "FLES",
          "url": "",
          "whatTheyDo": "Thu thập phản hồi khách hàng và nghiên cứu thị trường cho doanh nghiệp.",
          "industries": [
            "MARTECH"
          ],
          "stage": "",
          "geo": "",
          "roundDate": null,
          "outcomeNote": ""
        }
      ],
      "note": "Bốn doanh nghiệp được chương trình nêu trong phần chia sẻ của cựu thành viên, không phải toàn bộ danh sách các khoá. Chương trình cố vấn và kết nối với hệ sinh thái Shinhan, không đổi cổ phần.",
      "source": "https://futureslab.com.vn/innoboost/",
      "verifiedAt": "2026-09-27"
    },
    "provenance": {
      "sources": [
        {
          "url": "https://futureslab.com.vn/innoboost/",
          "fetchedAt": "2026-09-12",
          "note": "Trang chương trình chính thức"
        }
      ],
      "lastVerifiedAt": "2026-09-12"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-27T08:55:39.833Z",
    "updatedBy": "tramynguyento@gmail.com"
  },
  {
    "programId": "vinif-sci-tech-grant",
    "slug": "vinif-tai-tro-khoa-hoc-cong-nghe",
    "name": "VinIF — Tài trợ dự án Khoa học và Công nghệ",
    "shortName": "VinIF",
    "organizer": "Quỹ Đổi mới sáng tạo VinIF",
    "kind": "RESEARCH_GRANT",
    "website": "https://vinif.org",
    "logoUrl": "",
    "edition": {
      "label": "Theo đợt thường niên",
      "rolling": false,
      "opensAt": null,
      "closesAt": null
    },
    "benefit": {
      "capitalTypes": [
        "GRANT"
      ],
      "note": "Mức tài trợ công bố theo từng thông báo hằng năm."
    },
    "eligibility": {
      "stages": [
        "IDEA",
        "PROTOTYPE",
        "PRESEED",
        "SEED"
      ],
      "geos": [
        "VN"
      ],
      "industries": [
        "AI",
        "BIOTECH",
        "HEALTHTECH",
        "MATERIALS",
        "SEMICONDUCTOR"
      ],
      "hardRequirements": [
        "Dự án có định hướng ứng dụng và tính khoa học rõ ràng",
        "Chủ nhiệm và đơn vị chủ trì đủ điều kiện theo thông báo từng đợt"
      ]
    },
    "process": {
      "applyUrl": "https://vinif.org/"
    },
    "content": {
      "summary": "Chương trình tài trợ dự án khoa học công nghệ định hướng ứng dụng tại Việt Nam, không hoàn lại và không lấy cổ phần.",
      "tips": [
        "Đối tượng cốt lõi là nhà khoa học, viện và trường. Doanh nghiệp thuần thương mại có thể không đủ điều kiện nếu không có cấu trúc nghiên cứu phù hợp hoặc đối tác viện trường."
      ]
    },
    "provenance": {
      "sources": [
        {
          "url": "https://vinif.org/",
          "fetchedAt": "2026-09-11",
          "note": "Trang chính thức của quỹ"
        }
      ],
      "lastVerifiedAt": "2026-09-11"
    },
    "status": "PUBLISHED",
    "publish": {
      "status": "PUBLISHED"
    },
    "updatedAt": "2026-09-20T14:20:21.546Z",
    "updatedBy": "tramynguyento@gmail.com"
  }
];
